var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"projects"},[_c('h2',{staticClass:"title"},[_vm._v("Projekty, które zrealizowałem")]),_c('p',[_vm._v(" Wkrótce coś się tutaj pojawi! ")])])
}]

export { render, staticRenderFns }